import {Component, h, Prop} from '@stencil/core';
import {Article, DetailsComponents} from "../../utils/types";
import CloseIcon from "../../../atoms/svg-elements/close-icon";

@Component({
    tag: 'rtr-article-details-header',
    styleUrl: 'style.sass',
    shadow: false,
})
export class RtrArticleDetailsHeader {
    @Prop() article: Article;
    @Prop() detailsComponent: DetailsComponents;

    get imageClass(){
        if (this.detailsComponent.showHeaderImage) {
            return "ADHImage ADHImageVisible"
        }

        return "ADHImage"
    }

    render() {
        return (
            <div class="ADHWrapper">
                <div class={this.imageClass}>
                    <rentware-image
                        src={this.article.image}
                        alt={this.article.name}
                        vw={40}
                        vh={40}
                        forceAspectRatio={true}
                        onClick={() => this.detailsComponent.onShowFullGallery(true)}
                    />
                </div>
                <div class="ADHContainer">
                    <span class="ADHName">{this.article.name}</span>
                    <span class="ADHTitle">{this.article.title}</span>
                </div>
                <div
                    onClick={this.detailsComponent.onCloseButtonClick}
                    class="GlobalButtonSVG"
                    tabindex="0"
                >
                    <CloseIcon/>
                </div>
            </div>
        )
    }
}
